import { Fragment } from "react";
import Header from "../Components/CommonComponents/Header";
import Breadcrumbs from "../Components/CommonComponents/Breadcrumb";
import Footer from "../Components/CommonComponents/Footer";
import TapTop from "../Components/CommonComponents/TapTop";
import { Outlet } from "react-router-dom";
import Loader from "./Loader";
import TemplateCustomizer from "../Components/TemplateCustomizer";

const Layout = () => {
  return (
    <Fragment>
      <div className="inner-page">
        <Header />
        <Breadcrumbs />
      </div>
      <Outlet />
      <footer>
        <Footer />
      </footer>
      <TapTop />
      <Loader/>
      <TemplateCustomizer />
    </Fragment>
  );
};

export default Layout;
